import React, { useState } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';

const AddDeviceModal = ({ propertyId, stances, onClose, onAddDevice }) => {
  const [formData, setFormData] = useState({
    name: '',
    type: 'light',
    ha_id: '',
    state: false,
    stance: stances.length > 0 ? stances[0] : 'other', // Selecciona la primera estancia o "Otro"
    customStance: '', // Campo para estancia personalizada
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const selectedStance = formData.stance === 'other' ? formData.customStance.trim() : formData.stance;
    console.log(selectedStance);

    if (!formData.name || !formData.type || !formData.ha_id || !selectedStance) {
      alert('Todos los campos son obligatorios');
      return;
    }

    onAddDevice({ ...formData, stance: selectedStance, propertyId });
  };

  return (
    <AnimatePresence>
      <ModalOverlay
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <ModalContent
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
        >
          <h2>Añadir Dispositivo</h2>
          <form onSubmit={handleSubmit}>
            <label>Nombre</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <label>Tipo</label>
            <select
              name="type"
              value={formData.type}
              onChange={handleChange}
              required
            >
              <option value="light">Luz</option>
              <option value="plug">Enchufe</option>
              <option value="thermostat">Termostato</option>
              <option value="door">Puerta</option>
            </select>

            <label>ID de Home Assistant</label>
            <input
              type="text"
              name="ha_id"
              value={formData.ha_id}
              onChange={handleChange}
              required
            />

            <label>Estancia</label>
            <select
              name="stance"
              value={formData.stance}
              onChange={handleChange}
              required
            >
              {stances.map((stance, index) => (
                <option key={index} value={stance}>
                  {stance.charAt(0).toUpperCase() + stance.slice(1)}
                </option>
              ))}
              <option value="other">Otro</option>
            </select>

            {/* Campo de texto para estancia personalizada */}
            {formData.stance === 'other' && (
              <>
                <label>Nombre de la estancia</label>
                <input
                  type="text"
                  name="customStance"
                  value={formData.customStance}
                  onChange={handleChange}
                  placeholder="Introduce el nombre de la estancia"
                  required
                />
              </>
            )}

            <div className="button-group">
              <motion.button
                type="submit"
                className="save-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Añadir
              </motion.button>
              <motion.button
                type="button"
                className="cancel-btn"
                onClick={onClose}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Cancelar
              </motion.button>
            </div>
          </form>
        </ModalContent>
      </ModalOverlay>
    </AnimatePresence>
  );
};

const ModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const ModalContent = styled(motion.div)`
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 400px;
  text-align: center;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  position: relative;

  h2 {
    margin-bottom: 15px;
  }

  form {
    display: flex;
    flex-direction: column;
  }

  label {
    text-align: left;
    font-weight: bold;
    margin: 10px 0 5px;
  }

  input, select {
    padding: 10px;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .button-group {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }

  .save-btn {
    background-color: #008080;
    color: white;
    padding: 10px 15px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  .save-btn:hover {
    background-color: #006666;
  }

  .cancel-btn {
    background-color: #d9534f;
    color: white;
    padding: 10px 15px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  .cancel-btn:hover {
    background-color: #b52b27;
  }
`;

export default AddDeviceModal;